import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 12h3v4h-3l0 -4","key":"svg-0"}],["path",{"d":"M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6","key":"svg-1"}],["path",{"d":"M10 4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -3","key":"svg-2"}],["path",{"d":"M14 16h2","key":"svg-3"}],["path",{"d":"M14 12h4","key":"svg-4"}]]

const IconIdBadge2 = createReactComponent('outline', 'id-badge-2', 'IdBadge2', __iconNode);

export default IconIdBadge2;